import { render } from "./sales-representative-dashboard.vue?vue&type=template&id=f37fb338&scoped=true"
import script from "./sales-representative-dashboard.vue?vue&type=script&lang=js"
export * from "./sales-representative-dashboard.vue?vue&type=script&lang=js"

import "./sales-representative-dashboard.vue?vue&type=style&index=0&id=f37fb338&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37fb338"]])

export default __exports__